import React, { memo } from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const DataPoints = memo(function DataPoints() {
  const dataPoints = useSelector((state) => state.activePackages.dataPoints);

  if (!dataPoints?.length) return null;

  const [total, ...restDataPoints] = dataPoints;

  return (
    <div className="section">
      <div className="data-points">
        <div className="data-point">
          <DataDisplay label={total.label} value={total.value} url={total.url} />
        </div>
      </div>
      <div className="data-points">
        {restDataPoints.map((dataPoint) => (
          <div key={dataPoint.label} className="data-point">
            <DataDisplay {...dataPoint} />
          </div>
        ))}
      </div>
    </div>
  );
});

export default DataPoints;
